import { LegalLayout } from "@/components/LegalLayout";
import { COMPANY_NAME, P_IVA } from "@/constants/brand";

const Block = ({ title, children }) => (
  <section>
    <h2 className="font-display text-lg font-bold text-white mb-2.5">{title}</h2>
    <p>{children}</p>
  </section>
);

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" testid="privacy-policy-page">
      <Block title="1. Titolare del trattamento">
        Il titolare del trattamento dei dati personali è {COMPANY_NAME}, P.IVA {P_IVA}, in qualità di gestore della
        piattaforma "Io Amo La Mia Città".
      </Block>
      <Block title="2. Dati raccolti">
        Tramite i moduli presenti su questo sito raccogliamo: nome, cognome, indirizzo email, numero di telefono,
        età, città di residenza e città in cui si desidera lavorare, oltre al contenuto dei messaggi inviati
        volontariamente tramite la pagina Contatti.
      </Block>
      <Block title="3. Finalità del trattamento">
        I dati vengono utilizzati esclusivamente per gestire le candidature alla posizione di Responsabile delle
        Consegne, ricontattare i candidati per un colloquio conoscitivo e rispondere alle richieste inviate tramite
        il modulo contatti.
      </Block>
      <Block title="4. Base giuridica e conservazione">
        Il trattamento si basa sul consenso dell'interessato e sulle misure precontrattuali richieste. I dati sono
        conservati per il tempo necessario alla gestione della candidatura e comunque non oltre 24 mesi.
      </Block>
      <Block title="5. Diritti dell'interessato">
        In qualsiasi momento puoi richiedere l'accesso, la rettifica, la cancellazione o la limitazione del
        trattamento dei tuoi dati scrivendoci tramite la pagina Contatti.
      </Block>
    </LegalLayout>
  );
}
